import React from 'react';
import { Box, FormLabel, Stack, Switch, Typography } from '@mui/material';

export default function Default(props) {
  const {
    id,
    label,
    isChecked,
    onChange,
    desc,
    textWidth,
    reversed,
    fontSize,
    ...rest
  } = props;

  const switchEl = (
    <Switch
      checked={!!isChecked}
      id={id}
      size='medium'
      onChange={onChange}
    />
  );

  const labelEl = (
    <FormLabel
      htmlFor={id}
      sx={{
        cursor: 'pointer',
        maxWidth: textWidth || '75%',
        mb: 0,
      }}
    >
      <Typography variant='body1' fontWeight='500'>{label}</Typography>
      {desc && (
        <Typography
          color='text.secondary'
          sx={{ fontSize: fontSize || '1rem' }}
        >
          {desc}
        </Typography>
      )}
    </FormLabel>
  );

  return (
    <Box width='100%' fontWeight={500} {...rest}>
      {reversed ? (
        <Stack direction='row' alignItems='center' spacing='15px' sx={{ borderRadius: '16px' }}>
          {switchEl}
          {labelEl}
        </Stack>
      ) : (
        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ borderRadius: '16px' }}>
          {labelEl}
          {switchEl}
        </Stack>
      )}
    </Box>
  );
}
